// extracted by mini-css-extract-plugin
export default {"blank":"Blank_blank__bs9my","blankV2":"Blank_blankV2__gnyeb"};